import { firebaseApp } from '../firebase';
import { 
  getFirestore, 
  collection, 
  getDocs, 
  doc, 
  updateDoc, 
  setDoc, 
  getDoc,
  query,
  where,
  orderBy,
  limit
} from 'firebase/firestore';

interface TestResult {
  id: string;
  jobSeekerId: string;
  score: number;
  completedAt: any;
}

export const updateExistingProfilesWithVerification = async () => {
  const db = getFirestore(firebaseApp);
  
  
  try {
    // Get all test results from both collections
    const skillsValidationResults = await getDocs(collection(db, 'skillsValidationResults'));
    const jobseekerResults = await getDocs(collection(db, 'jobseekerResults'));
    
    const allResults: TestResult[] = [];
    
    // Process skills validation results
    skillsValidationResults.forEach(doc => {
      const data = doc.data();
      if (data.score && data.jobSeekerId) {
        allResults.push({
          id: doc.id,
          jobSeekerId: data.jobSeekerId,
          score: data.score,
          completedAt: data.completedAt
        });
      }
    });
    
    // Process jobseeker results
    jobseekerResults.forEach(doc => {
      const data = doc.data();
      if (data.score && data.jobSeekerId) {
        allResults.push({
          id: doc.id,
          jobSeekerId: data.jobSeekerId,
          score: data.score,
          completedAt: data.completedAt
        });
      }
    });
    
    
    // Group results by jobSeekerId and find the highest score for each
    const bestScoresByUser = new Map<string, { score: number, completedAt: any }>();
    
    allResults.forEach(result => {
      const existing = bestScoresByUser.get(result.jobSeekerId);
      if (!existing || result.score > existing.score) {
        bestScoresByUser.set(result.jobSeekerId, {
          score: result.score,
          completedAt: result.completedAt
        });
      }
    });
    
    
    // Update profiles for users with scores >= 60%
    let updatedCount = 0;
    
    for (const [userId, bestScore] of bestScoresByUser.entries()) {
      if (bestScore.score >= 60) {
        try {
          const profileRef = doc(db, 'userProfiles', userId);
          const profileDoc = await getDoc(profileRef);
          
          const updateData = {
            skillsVerified: true,
            verificationScore: bestScore.score,
            verificationDate: bestScore.completedAt || new Date(),
            lastUpdated: new Date()
          };
          
          if (profileDoc.exists()) {
            // Update existing profile
            await updateDoc(profileRef, updateData);
          } else {
            // Create new profile with verification
            await setDoc(profileRef, {
              userId: userId,
              ...updateData,
              createdAt: new Date()
            });
          }
          
          updatedCount++;
        } catch (error) {
        }
      }
    }
    
    return { updated: updatedCount, total: bestScoresByUser.size };
    
  } catch (error) {
    throw error;
  }
};

// Function to run the update (can be called from console or component)
export const runProfileUpdate = async () => {
  try {
    const result = await updateExistingProfilesWithVerification();
    return result;
  } catch (error) {
    return null;
  }
};